'use client';

import { createContext, useRef } from 'react';

export const SourcePageTrackerContext = createContext({});

const SourcePageTrackerProvider = ({ children, sourcePageData }) => {
    return (
        <SourcePageTrackerContext.Provider value={{ sourcePageData }}>
            {children}
        </SourcePageTrackerContext.Provider>
    );
};

export default SourcePageTrackerProvider;

// global tracker
export const GlobalSourcePageTrackerContext = createContext({});

export const GlobalSourcePageTrackerProvider = ({ children }) => {
    const currentSourcePageDataRef = useRef(null);

    const setCurrentSourcePageDataRef = (data) => {
        currentSourcePageDataRef.current = data;
    };

    return (
        <GlobalSourcePageTrackerContext.Provider
            value={{ currentSourcePageDataRef, setCurrentSourcePageDataRef }}>
            {children}
        </GlobalSourcePageTrackerContext.Provider>
    );
};
